import axios from 'axios';

const coopConfirmCancel = async ({
  appointmentId,
  status,
  details,
}: {
  appointmentId: string;
  status: 'confirm' | 'cancel';
  details?: string;
}) => {
  const { data } = await axios.post(
    `/user/coop/appointments/${appointmentId}/status`,
    {
      status,
      details,
    },
  );
  return data;
};

export default coopConfirmCancel;
